import React from 'react';
import { CardProps } from '../../types/pipeline.types';
import './Card.styles.css';

export const Card: React.FC<CardProps> = ({
  variant = 'flat',
  padding = 'medium',
  children
}) => {
  return (
    <div className={`card card--${variant} card--padding-${padding}`}>
      {children}
    </div>
  );
};